import { CommonEntrypoint } from "entrypoint/CommonEntrypoint";
import 'presentation/style/index.scss';
import CreditNoteDetailContMain from "presentation/view/container/CreditNote/CreditNoteDetailContMain";

CommonEntrypoint(<CreditNoteDetailContMain/>)